import { baseUrl } from '../util';
import request from '@/utils/request';

export const getProductDetail = (handle: string, locale: string) => {
    const result = request(`${baseUrl(locale)}/product/detail/data?handle=${handle}&locale=${locale}`, {
        method: 'get',
    });

    return result;
};
